module.exports = __webpack_public_path__ + "img/tab-1.ea02b5d7.png";